import { ReactNode, useCallback, useState } from 'react';

import {
    ImageLightboxContext,
    ImageLightboxContextType,
} from './ImageLightboxContext';

import { ImageLightbox } from '../ui/ImageLightbox';

interface ImageLightboxProviderProps {
    children: ReactNode;
}

export const ImageLightboxProvider = ({
    children,
}: ImageLightboxProviderProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [imageUrl, setImageUrl] = useState<string | null | undefined>(null);

    const openLightbox = useCallback((url: string | null | undefined) => {
        setImageUrl(url);
        setIsOpen(true);
    }, []);

    const closeLightbox = useCallback(() => {
        setIsOpen(false);
        setTimeout(() => {
            setImageUrl(null);
        }, 300);
    }, []);

    const context: ImageLightboxContextType = {
        openLightbox,
        closeLightbox,
        imageUrl,
        isOpen,
    };

    return (
        <ImageLightboxContext.Provider value={context}>
            {children}
            <ImageLightbox
                open={isOpen}
                onClose={closeLightbox}
                imageUrl={imageUrl}
            />
        </ImageLightboxContext.Provider>
    );
};
